module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Note":"Note","End":"End"," Are you sure you want to exit the room":" Are you sure you want to exit the room?"},"zh":{"Note":"温馨提示","End":"结束直播"," Are you sure you want to exit the room":"确认退出直播间吗?"}}')
  delete Component.options._Ctor
}
